import {
    Button,
    TextField,
    MuiThemeProvider,
    createMuiTheme
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useSkeleton } from '../../../hooks/useSkeleton'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { deleteProjectTitle, getProjectTitleById, postProjectTitle, updateProjectTitle } from '../../../../api/projectTitles'
import { getAllActiveTechnologies } from '../../../../api/technology'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { Autocomplete } from '@material-ui/lab'
import { getNonEmpty } from '../../../../utils/helpers'

// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyText() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        typeTech: ""
    }
}


function getActiveTech(technologies) {
    return technologies
        .map((technology) => {
            const titleLowerCase = getNonEmpty(technology?.title).toLowerCase();
            let techType = ""

            if (titleLowerCase.includes("solar"))
                techType = "solar";
            if (titleLowerCase.includes("storage"))
                techType = "storage";
            if (titleLowerCase.includes("wind"))
                techType = "wind";
            if (titleLowerCase.includes("hydrogen"))
                techType = "hydrogen";

            return {
                title: getNonEmpty(technology?.title),
                _id: techType
            };
        });
}

export default function EditProjectTitle() {
    const projectTitleId = useParams().id;
    const history = useHistory();
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

    const [projectTitle, setProjectTitle] = useState(getEmptyText())
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const [technologies, setTechnologies] = useState([]);


    useEffect(() => {
        getAllActiveTechnologies()
            .then((res) => { setTechnologies(getActiveTech(res.data)) })
            .catch((error) => { alertError({ error: error, customMessage: "Could not get technologies." }); })

        if (!projectTitleId) {
            disableLoadingData();
            return
        }

        getProjectTitleById(projectTitleId).then(res => {
            setProjectTitle(res.data)
            disableLoadingData()
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get project tilte.' })
            history.push('/projectTitles')
        })

    }, [disableLoadingData, history, projectTitleId])

    function saveProjectTitle() {
        projectTitle.typeTech = projectTitle.typeTech?._id;

        if (!projectTitleId) {
            postProjectTitle(projectTitle)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Project title created successfully.",
                    });
                    history.push("/projectTitles");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the project title.",
                    });
                });
        } else {
            updateProjectTitle(projectTitleId, projectTitle).then(res => {
                alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
                history.push('/projectTitles')
            }).catch(error => {
                alertError({ error: error, customMessage: 'Could not save changes.' })
            })
        }
    }

    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!projectTitle[element])
                projectTitle[element] = {}
            let newText = projectTitle[element]
            newText[lang] = event.target.value
            setProjectTitle({ ...projectTitle, [element]: newText })
        } else
            setProjectTitle({ ...projectTitle, [element]: event.target.value })
    }

    const renderMultilanguageTabContent = lang => {
        return (
            <div className='row'>
                <div className='col-6'>
                    <TextField
                        label="Title"
                        value={(projectTitle.title && projectTitle.title[lang]) || ''}
                        onChange={handleChange('title', lang)}
                        margin="normal"
                        variant="outlined"
                        required
                    />
                </div>

                <div className='col-6'>
                    <Autocomplete
                        id='Technology'
                        options={technologies}
                        value={projectTitle.typeTech || null}
                        getOptionLabel={(option) => option.title}
                        onChange={(_, newValue) => {
                            setProjectTitle({
                                ...projectTitle,
                                typeTech: newValue
                            })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label='Status'
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        )}

                    />
                </div>


            </ div>
        )
    }


    if (isLoadingData)
        return <ContentSkeleton />

    return (
        <>
            <Card>
                <CardHeader title='Edit project title'>
                </CardHeader>
                <CardBody>

                    <MultilanguageTabBlock
                        multilanguageTabContent={renderMultilanguageTabContent}
                    />


                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/projectTitles')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Back
            </Button>
            <Button
                onClick={() => saveProjectTitle()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save project title
            </Button>

            {projectTitle?.active && (
                <>
                    <MuiThemeProvider theme={theme}>
                        <Button
                            onClick={() => setOpenConfirmDialog(true)}
                            variant="outlined"
                            color="secondary"
                            style={{ marginRight: "20px" }}
                        >
                            Delete project title
                        </Button>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "auto",
                            }}
                        ></div>
                    </MuiThemeProvider>

                    <ConfirmDialog
                        title={"Are you sure you want to delete this project title?"}
                        open={openConfirmDialog}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteProjectTitle(projectTitleId)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Project title deleted successfully.",
                                    });
                                    history.push("/projectTitles");
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the project title.",
                                    });
                                });
                        }}
                    />
                </>
            )}
        </>
    );
}